import { localizationService, Resource } from 'src/services';
import { RestSlice } from '../../../../redux/rest.slice';
import { FogNoticesHistory } from '@rcp/types';

export const fogNoticesHistoriesSlice = new RestSlice<FogNoticesHistory>(
	localizationService.getLocalizedString('noticesHistory.noticeHistory'),
	Resource.FogNoticesHistories
);
export const fogNoticesHistorySliceReducer = fogNoticesHistoriesSlice.rests.reducer;
